/**
 * orderFields — Sipariş kaydındaki çifte alanlar için TEK okuma sözleşmesi.
 *
 * Şema evrimi nedeniyle orders tablosu aynı veriyi iki alanda taşır:
 *   - Kalemler: `positionen` (motor) ve `items` (legacy) — içerik aynı
 *   - Toplam:   `total` (EN) ve `gesamtsumme` (DE legacy)
 *
 * Tüm tüketiciler bu yardımcıları kullanmalı; ad-hoc `positionen ?? items`
 * ve `total ?? gesamtsumme` kalıpları buraya taşındı.
 */
import { parseArrayField } from '@/lib/jsonField';

/**
 * Sipariş kalemlerini güvenli okur (positionen → items → order_items).
 * @param {object} order
 * @param {{ onError?: (msg: string) => void }} [options]
 * @returns {Array<any>}
 */
export function getOrderItems(order, options = {}) {
  const raw = order?.positionen ?? order?.items ?? order?.order_items ?? [];
  return parseArrayField(raw, { fieldName: 'positionen', ...options });
}

/**
 * Sipariş toplamını okur (total → gesamtsumme).
 * @param {object} order
 * @returns {number}
 */
export function getOrderTotal(order) {
  const value = parseFloat(order?.total ?? order?.gesamtsumme ?? 0);
  return Number.isFinite(value) ? value : 0;
}

/**
 * Angebot mu? order_type büyük/küçük harf duyarsız; tip eksikse
 * belge numarası ön ekinden (ANG-/AN-) çıkarım yapılır.
 * @param {object} order
 * @returns {boolean}
 */
export function isAngebot(order) {
  const type = (order?.order_type || '').trim().toLowerCase();
  if (type) return type.includes('angebot');
  const num = (order?.order_number || '').toUpperCase();
  return num.startsWith('ANG') || num.startsWith('AN-');
}

/**
 * Bestellung mu? (Angebot olmayan her sipariş kaydı)
 * @param {object} order
 * @returns {boolean}
 */
export function isBestellung(order) {
  return !isAngebot(order);
}
